export default "__VITE_ASSET__BhXCClzY__"